<!-- <ngx-spinner></ngx-spinner> -->

<!-- <ngx-spinner bdColor="rgba(0,0,0,0.1)" size="medium" color="#464343" type="ball-spin-clockwise"></ngx-spinner> -->
<ngx-spinner bdColor="rgba(158, 205, 221)" style="opacity: 0.8;position: relative;z-index: 9999;" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <img src="../assets/images/new-images/loaderouk.gif" alt="Loading...">
    <p style="color: #041c28; font-weight: bold;" class="text-center">Loading...</p>
</ngx-spinner>
<router-outlet></router-outlet>